import React from 'react';
import PropTypes from 'prop-types';

const LockNot = ({ color = '#BCC6CA', fillColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      d="M18.562 2.8v-.5a1 1 0 0 0-1-1H4.52a1 1 0 0 0-1 1v17.675M18.562 18.3v.675a1 1 0 0 1-1 1h-2.804"
    />
    <path
      fill={fillColor}
      d="M16.922 5.45h2.606A1.472 1.472 0 0 1 21 6.922v1.912a1.47 1.47 0 0 1-1.472 1.472h-.218v4.745c0 .24-.084.473-.239.657l-.06.066-.424.425a.512.512 0 0 1-.679.04l-.045-.04-.424-.425a1.023 1.023 0 0 1-.295-.633l-.004-.09v-.3l.723-.723-.723-.723.723-.724-.723-.724v-1.55h-.218a1.471 1.471 0 0 1-1.472-1.473V6.922a1.47 1.47 0 0 1 1.472-1.472Zm1.303 2.428.004-.004-.004.004Z"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m18.225 7.878.004-.004M16.922 5.45h2.606A1.472 1.472 0 0 1 21 6.922v1.912a1.47 1.47 0 0 1-1.472 1.472h-.218v4.745c0 .24-.084.473-.239.657l-.06.066-.424.425a.512.512 0 0 1-.679.04l-.045-.04-.424-.425a1.023 1.023 0 0 1-.295-.633l-.004-.09v-.3l.723-.723-.723-.723.723-.724-.723-.724v-1.55h-.218a1.471 1.471 0 0 1-1.472-1.473V6.922a1.47 1.47 0 0 1 1.472-1.472Z"
    />
    <path
      stroke={color}
      d="M3.5 2.82a.5.5 0 0 1 .654-.476l7.856 2.541a.5.5 0 0 1 .346.476v16.633a.5.5 0 0 1-.63.483L3.87 20.356a.5.5 0 0 1-.37-.483V2.82Z"
    />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={fillColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

LockNot.propTypes = {
  color: PropTypes.string,
  fillColor: PropTypes.string
};

export default LockNot;
